import React, { useEffect, useState } from "react";
import Table from "./Table";

const ProductList = () => {
    const[items,setItems]=useState([]);
    useEffect(()=>{
        fetch("https://sleepy-depths-81993.herokuapp.com/items")
        .then(res => res.json())
        .then(data => setItems(data))
    },[])
  return (
    <div className="w-50 m-auto mt-5">
      <table class=" table table-striped">
        <thead>
          <tr>
            <th scope="col">id</th>
            <th scope="col">Subject</th>
            <th scope="col">Name</th>
            <th scope="col">Price</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
        {
                                 items.map(item => <Table key={item._id} item={item}></Table>)
                          }
        </tbody>
      </table>
    </div>
  );
};

export default ProductList;
